export default __webpack_public_path__ + "static/media/User_alt_light.877bd568.svg";